// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Comparison_wrap__e40Xv","clear":"Comparison_clear__47PnE"};